<template lang="pug">
  .container
    .restriction-row(v-if='sortedRestrictions.length > 0')
      .restriction-day(v-for="n in 7", :key="n")
        .day-label {{ $t(dayLabelLength + days[n - 1]) }}
    .restriction-row(
      v-for="(restriction, index) in sortedRestrictions",
      :key="restriction.id",
      :id="'ScheduleDayTimeList-restrictionRow' + restriction.id"
    )
      el-button.calendar-icon(
        v-if='restriction.validFrom || restriction.validTo',
        :title='restriction.validFrom + "  -  " + restriction.validTo',
        type='text',
        size='mini'
      )
        font-awesome-icon(
          icon="calendar-alt",
          :class='{ "danger": validateRestriction(restriction) === "past", "success" :  validateRestriction(restriction) === "future", "warning" :  validateRestriction(restriction) === "current" }'
        )
      .restriction-day(v-for="n in 7", :key="n")
        .day-times(:class= "{ allday: showDTRestrictionFor(days[n - 1], restriction) === '24h',  off: showDTRestrictionFor(days[n - 1], restriction) === 'off' }") {{showDTRestrictionFor(days[n - 1], restriction)}}
</template>

<script>
import mediaUtils from '../Common/mediaUtils.mixin'
export default {
  mixins: [mediaUtils],
  props: ['restrictions', 'dayLabelLength'],
  mounted () {
  },
  data () {
    return {
      errors: {},
      days: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ]
    }
  },
  methods: {
    showDTRestrictionFor (day, restriction) {
      if (restriction['start_' + day] === '00:00' && restriction['end_' + day] === '24:00') return '24h'
      if (restriction['start_' + day] === '00:00' && restriction['end_' + day] === '00:00') return 'off'
      return restriction['start_' + day] + '-' + restriction['end_' + day]
    }
  },
  computed: {
    sortedRestrictions () {
      return this.restrictions.slice()
        .sort((a, b) => (a.start_Monday > b.start_Monday) ? 1 : ((b.start_Monday > a.start_Monday) ? -1 : 0))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container {
  width: 100%;
  .restriction-row {
    display: flex;
    .calendar-icon {
      margin-left: -12px;
      margin-top: -8px;
    }
    .restriction-day {
      white-space: nowrap;
      font-size: $--font-size-base;
      width: calc(100%/7);
      text-align: center;
      .day-label {
        color: $--color-text-regular;
      }
      .allday {
        color: $--color-success !important;
      }
      .off {
        color: $--color-danger !important;
      }
      :not(.day-label) {
        color: $--color-text-secondary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/ScheduleDayTimeList.vue